import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth/authRoles';

import IdvPage from './IdvPage';

const IdvRoute: FuseRouteItemType = {
  path: '',
  element: <IdvPage />,
  auth: AUTH_ROLES.parent, // []
  children: [],
};

export default IdvRoute;
